<div class="historial-container">
  <h2 mat-dialog-title>Detalles de Resolución</h2>
  <mat-dialog-content>
    <div class="timeline">
      <div
        class="timeline-item"
        *ngFor="let historyItem of sortedHistorial; let last = last"
      >
        <div class="timeline-time">{{ formatDate(historyItem.timestamp) }}</div>

        <div class="timeline-indicator">
          <div
            class="circle"
            [ngClass]="
              (historyItem.incidentStatus
                ? historyItem.incidentStatus
                : 'DEFAULT'
              ) | lowercase
            "
          ></div>
          <div class="line" *ngIf="!last"></div>
        </div>

        <div class="timeline-content">
          <ng-container
            *ngIf="data.incidentType === 'INCIDENCIA_PRE_OPERATIVA'"
          >
            <ng-container *ngIf="historyItem.incidentStatus === 'PENDING'">
              Observación creada desde Programación por
              {{ historyItem.updatedBy }}.
            </ng-container>
            <ng-container *ngIf="historyItem.incidentStatus === 'RESOLVED'">
              Observación <span class="text-orange">resuelta por DS</span>
              {{ historyItem.updatedBy }} en Sales.
            </ng-container>
            <ng-container *ngIf="historyItem.incidentStatus === 'NOT_APPROVED'">
              Observación revisada <span class="text-red">No Aprobada</span> por
              {{ historyItem.updatedBy }}.
            </ng-container>
            <ng-container *ngIf="historyItem.incidentStatus === 'APPROVED'">
              Observación revisada <span class="text-green">Aprobada</span> por
              {{ historyItem.updatedBy }}.
            </ng-container>
            <ng-container *ngIf="!historyItem.incidentStatus">
              Observación editada por {{ historyItem.updatedBy }}.
            </ng-container>
          </ng-container>

          <ng-container *ngIf="data.incidentType === 'REVISION_AC'">
            <ng-container *ngIf="historyItem.incidentStatus === 'PENDING'">
              Observación creada desde Atención al Cliente por
              {{ historyItem.updatedBy }}.
            </ng-container>
            <ng-container *ngIf="historyItem.incidentStatus === 'RESOLVED'">
              Observación <span class="text-orange">resuelta por Prog.</span>
              {{ historyItem.updatedBy }}.
            </ng-container>
            <ng-container *ngIf="historyItem.incidentStatus === 'NOT_APPROVED'">
              Observación revisada <span class="text-red">No Aprobada</span> por
              {{ historyItem.updatedBy }}.
            </ng-container>
            <ng-container *ngIf="historyItem.incidentStatus === 'APPROVED'">
              Observación revisada <span class="text-green">Aprobada</span> por
              {{ historyItem.updatedBy }}.
            </ng-container>
            <ng-container *ngIf="!historyItem.incidentStatus">
              Observación editada por {{ historyItem.updatedBy }}.
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Migration Info Note -->
    <div class="info-note" *ngIf="hasSistemaMigration">
      <span class="info-icon">ℹ</span>
      <p>
        <strong>Nota:</strong> Los registros actualizados por
        "<strong>Sistema</strong>" corresponden a la migración de datos
        históricos.
      </p>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button class="btn-cerrar" (click)="close()">
      Cerrar
    </button>
  </mat-dialog-actions>
</div>
